// @flow

import React from 'react';
import bemify from 'bemify-js';

import { Colors } from '@zapier/design-system';
import { LoginForm } from '@zapier/authentication';
import { urlWithNext } from '@zapier/url-utils';

import Config from 'app/common/Config';
import LinkPreserveParamsContainer from 'app/common/components/LinkPreserveParamsContainer';
import ZapierAuthenticationContainer from 'app/login/components/ZapierIdentityAuth/ZapierAuthenticationContainer';
import { PLATFORM_LOGIN_URL } from 'app/login/constants';

const bem = bemify('zapier-authentication');

const ZapierAuthenticationLogin = () => {
  return (
    <ZapierAuthenticationContainer>
      {({ invitation, isPlatformPage, queryParameters, routeTo }) => {
        const next =
          queryParameters.next || (isPlatformPage ? PLATFORM_LOGIN_URL : null);
        const signUpUrl = urlWithNext('/sign-up/?skipOnboarding=true', next);

        return (
          <React.Fragment>
            <LoginForm
              enableEmailAutoFocus={true}
              forceLoginDisplayForm={queryParameters.forceLoginDisplayForm}
              googleCaptchaSiteKey={Config.googleCaptchaSiteKey}
              invitation={invitation}
              next={next}
              queryParams={queryParameters}
              routeTo={routeTo}
              showSignupLink={false} // we add our own link below that accounts for /platform routes
            />
            <p className={bem(`__footer`)}>
              Don&apos;t have a Zapier account yet?{'\u00A0'}
              <LinkPreserveParamsContainer
                href={signUpUrl}
                kind="blue"
                style={{ color: Colors.blue }}
              >
                Sign Up
              </LinkPreserveParamsContainer>
            </p>
          </React.Fragment>
        );
      }}
    </ZapierAuthenticationContainer>
  );
};

export default ZapierAuthenticationLogin;
